import React from 'react';
import classnames from 'classnames';
import User from 'app/scripts/models/user';

export interface UserControlsProps {
  user: User;
  onItemSelected: () => void;
}

interface Props extends UserControlsProps {
  addReporter: (user: User) => void;
  alreadyAssigned?: boolean;
}

const AddReporterControls: React.FC<Props> = ({
  user,
  addReporter = (user: User) => {},
  onItemSelected = () => {},
  alreadyAssigned
}) => {
  const onClick = () => {
    addReporter(user);
    onItemSelected();
  };

  return (
    <div className="buttons">
      <button
        className={classnames('moderator-button', alreadyAssigned && 'disabled')}
        onClick={onClick}
        disabled={alreadyAssigned}
      >
        {alreadyAssigned ? 'Assigned' : 'Assign'}
      </button>
    </div>
  );
};

export default AddReporterControls;
